export default "__VITE_ASSET__ee02a9ce__"